import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthUtilService } from '../../services/auth-util.service';
import { SuiteUserAuth } from '../../model/suite-user-auth';

@Injectable({
  providedIn: 'root'
})
export class AuthServiceResolver implements Resolve<Observable<any>> {

  constructor(
    private authUtilService: AuthUtilService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<SuiteUserAuth> | Observable<never> {
    return of(this.authUtilService.userValue);
  }
}
